/* preprod_v2 */
const config = {
    logLevel: "info",
    baseHref: "/",
    title: "widgets",
}
export default config
